import React from "react";

import { Icon } from "aible";

import styles from "./style.module.css";

export default class Dropdown extends React.Component {
  state = {
    hide: true,
    localSelected: null
  };

  handleToggle(override = false) {
    const { onClick, isLocked } = this.props;
    const { hide } = this.state;

    if (!isLocked) {
      this.setState({ hide: override || !hide });
    }
    if (onClick) {
      return onClick();
    }
  }

  handleSelect(event, option) {
    const { onChange } = this.props;
    if (!option.noSelect) {
      this.setState({
        localSelected: option.value,
        hide: true
      });
    }
    if (option.onClick) {
      option.onClick(event);
      if (option.overrideClick) {
        return;
      }
    }
    if (onChange) {
      return onChange(option);
    }
  }

  render() {
    const { selected, options, optionsProps, onChange, onClick, isDark, isLocked, ...retProps } = this.props;
    const { hide, localSelected } = this.state;

    const { className, ...retOptionsProps } = optionsProps || {};

    let selectedOption = null;
    let maxChars = 0;
    const sCheck = selected === undefined ? localSelected : selected;
    if (options) {
      for (let i = 0; i < options.length; i++) {
        const cOption = options[i];
        if (cOption.value === sCheck) {
          selectedOption = cOption;
        }
      }
    }

    return (
      <div className={styles.dropdownWrapper} onMouseLeave={() => this.handleToggle(true)}>
        <div style={{ height: "0px", overflow: "hidden", visibility: "hidden" }}>
          <Trigger {...retProps} isDark={isDark} selectedOption={null} />
          {options.map((option, i) => (
            <Trigger
              isDark={isDark}
              key={"dropdown-triggers" + i + option.value}
              {...retProps}
              selectedOption={option}
            />
          ))}
        </div>
        <Trigger
          {...retProps}
          onClick={() => this.handleToggle()}
          hide={hide}
          isDark={isDark}
          selectedOption={selectedOption}
          isLocked={isLocked}
        />
        {options && options.length > 0 ? (
          <div
            {...retOptionsProps}
            className={styles.optionsWrapper + " " + styles.hide + " " + (className ? className : "")}
            style={{ position: "relative", border: "0px" }}
          >
            {options &&
              options.map((option, i) => (
                <Option isDark={isDark} key={"dropdown-spacer" + i + option.value} {...option} onClick={() => {}} />
              ))}
          </div>
        ) : (
          ""
        )}
        {options && options.length > 0 ? (
          <div
            {...retOptionsProps}
            className={styles.optionsWrapper + " " + (hide ? styles.hide : "") + " " + (className ? className : "")}
          >
            {options &&
              options.map((option, i) =>
                option.hide ? (
                  ""
                ) : (
                  <Option
                    isDark={isDark}
                    key={"dropdown-option" + i + option.value}
                    {...option}
                    onClick={(event) => this.handleSelect(event, option)}
                  />
                )
              )}
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

class Trigger extends React.PureComponent {
  render() {
    const {
      className,
      placeholder,
      triggerProps,
      icon,
      iconProps,
      hide,
      selectedOption,
      isDark,
      isLocked,
      ...retProps
    } = this.props;
    const { triggerClass, ...retTriggerProps } = triggerProps || {};
    const { iconClass, ...retIconProps } = iconProps || {};
    return (
      <div
        {...retProps}
        className={
          styles.dropdownTriggerWrapper +
          " " +
          (isDark ? styles.darkMode : "") +
          " " +
          (!hide ? styles.active : "") +
          " " +
          (isLocked ? styles.locked : "") +
          " " +
          (className ? className : "")
        }
      >
        <div {...retTriggerProps} className={styles.dropdownTrigger + " " + (triggerClass ? triggerClass : "")}>
          {selectedOption ? selectedOption.selected || selectedOption.label : placeholder || "Select..."}
        </div>
        <div
          {...retIconProps}
          className={
            styles.dropdownIcon +
            " " +
            (isDark ? styles.darkMode : "") +
            " " +
            (isLocked ? styles.locked : "") +
            " " +
            (iconClass ? iconClass : "")
          }
        >
          {icon ? icon : <Icon size={10} type={"arrowDown"} />}
        </div>
      </div>
    );
  }
}

class Option extends React.PureComponent {
  render() {
    const {
      label,
      value,
      selected,
      className,
      isSelected,
      disabled,
      onClick,
      hide,
      isDark,
      noHover,
      overrideClick,
      noSelect,
      ...retProps
    } = this.props;

    return (
      <div
        {...retProps}
        className={
          styles.option +
          " " +
          (noHover ? styles.noHover : "") +
          " " +
          (isDark ? styles.darkMode : "") +
          " " +
          (isSelected ? styles.isSelected : "") +
          " " +
          (disabled ? styles.disabled : "") +
          " " +
          (className ? className : "")
        }
        onClick={disabled ? undefined : onClick}
      >
        {label}
      </div>
    );
  }
}
